import { AnaColumn } from "../forms-template.service";
import { aspect } from "./aspect";

export const AlboCer: AnaColumn[] = [
  {
    itemType: "",

    configuration:
    {

      titleGriglia: '$descSoggetto  $descrizioneSede',
      titleForm: '$descSoggetto  $descrizioneSede',
      breadcrumbCaption: 'Categorie Albo',
      idBreadcrumbGroup: 'AlboCategoria',
      campoTitle: ['descrizioneSede', 'descSoggetto'],
      masterKey: 'id',
      service: 'AlboCer',
      api: 'AlboCer',
      filterList: '?idAlboCategoria=$idAlboCategoria',
      filterEditor: '?id=$',
      formType: 'simple',
      helpDoc: 'CategoriaAlbo.html',
      idTabRif: [
        {
          key: 'idSede',
          value: 'idSede'
        },
      ],
      queryFilter: [

      ],
      nCol: 1,
      toolbarSettings: {
        service: 'alboCategoria',
       

      }

    }


  },
  {
    itemType: "group", colCount: "1", data: [

      { type: 'campo', dataField: "idTipoIscrizioneAlbo", dataType: "", caption: "", colVisible: false, hideOnEdit: true },
      {
        type: 'campo', dataField: "cer", dataType: "", caption: "",
        maxLength: '6', width: 8 +'vw', maxSize: 6,
        class: "required", validation: [
          { type: "required", message: "Campo Obbligatorio" }
        ],
        colWidth:'30',
        lista:{
          dataSource:'cer',
          valueExpr:'id',
          displayExpr:'id',
          static:false
        }
      },

      { 
        allowEditing: false, type: 'campo', dataField: "Descrizione", dataType: "", caption: "", hideOnEdit: true, disabled: true,
        colWidth:'250',
      },
    ]
  },
];